export default "__VITE_ASSET__DAvwc3D4__"